<template>
<div class="platform">
  <ScreenPanel :isExpand="isLeft">
    <ScreenBoxClick title="月台占用比例" menuCode="120102">
      <OccupancyRatio/>
    </ScreenBoxClick>
    <ScreenBox title="预约单分配">
      <dispatch-table :columnData="platformColumnData" :table-data="platformTableData"/>
    </ScreenBox>
    <!-- 统计当天的 -->
    <ScreenBox title="月台车辆停靠统计">
      <VehicleParking/>
    </ScreenBox>
  </ScreenPanel>
  <!-- 未开始，进行中统计预约单 -->
  <!-- 已完成统计当天 -->
  <ScreenPanel :isExpand="isRight" position="right">
    <ScreenBox title="预约单统计">
      <Appointment/>
    </ScreenBox>
    <ScreenBox title="作业效率统计">
      <dispatch-table :columnData="jobColumnData" :table-data="jobTableData"/>
    </ScreenBox>
  </ScreenPanel>
</div>
</template>

<script>
import ScreenPanel from "@ISS/situation/components/ScreenPanel";
import ScreenBox from "@ISS/situation/components/ScreenBox";
import ScreenBoxClick from "../components/ScreenBoxClick.vue";
import OccupancyRatio from "@ISS/situation/components/OccupancyRatio";
import DispatchTable from "@ISS/situation/components/dispatchTable";
import VehicleParking from "@ISS/situation/components/VehicleParking";
import Appointment from "@ISS/situation/components/Appointment";
import api from '../api'

export default {
  name: "Platform",
  components: {Appointment, VehicleParking, DispatchTable, OccupancyRatio, ScreenBox, ScreenBoxClick, ScreenPanel},
  data() {
    return {
      isLeft: false,
      isRight: false,
      platformColumnData: [
        {
          label: '序号',
          prop: 'index',
          width: 60
        }, {
          label: '车牌号',
          prop: 'vehicleNumber',
          width: 95
        }, {
          label: '调度分配时间',
          prop: 'dispatchTime',
          width: 160
        }, {
          label: '冷库名称',
          prop: 'storageName',
          width: 80
        }, {
          label: '月台号',
          prop: 'platformCode'
        }],
      platformTableData: [],
      jobColumnData: [
        {
          label: '序号',
          prop: 'index',
          width: 60
        }, {
          label: '车牌号',
          prop: 'vehicleNumber',
        }, {
          label: '月台号',
          prop: 'platformCode'
        }, {
          label: '库管',
          prop: 'storekeeperName'
        }, {
          label: '作业时间(分钟)',
          prop: 'workTimeLong'
        }
      ],
      jobTableData: []
    }
  },
  beforeDestroy() {
    this.$map.hideMap2D();
  },
  mounted() {
    this.isLeft = true;
    this.isRight = true;
    this.$map.showMap2D();
    this.queryInfo()
  },
  methods: {
    queryInfo() {
      this.$fetch(api.platform.queryAppointmentWork).then(res => {
        if (res.success) {
          this.platformTableData = res.returnObj
        }
      })
      this.$fetch(api.platform.queryWorkProductiveness).then(res => {
        if (res.success) {
          this.jobTableData = res.returnObj
        }
      })
    }
  },
}
</script>

<style lang="scss" scoped>
.platform {

}
</style>
